import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type WorkspaceAgentElicitationComponentType } from './useTrackAgentElicitationRequested.meta';
import META, {
  type WorkspaceAgentElicitationDecision,
  type WorkspaceAgentElicitationRespondedCta,
  type WorkspaceAgentElicitationRespondedType,
} from './useTrackAgentElicitationResponded.meta';
import { type WorkspaceAgentGuidedFlowEditId } from './useTrackAgentTaskSubmitted.meta';
import { withWorkspaceAgentCategory } from './workspaceAgentAnalytics';

export type {
  WorkspaceAgentElicitationDecision,
  WorkspaceAgentElicitationRespondedCta,
  WorkspaceAgentElicitationRespondedType,
} from './useTrackAgentElicitationResponded.meta';

type WorkspaceAgentElicitationRespondedSharedParams = {
  chat_id: string;
  cta: WorkspaceAgentElicitationRespondedCta;
  decision: WorkspaceAgentElicitationDecision;
  elicitation_id: string;
  remember_for_session: boolean;
  response_time_ms?: number;
  selected_count?: number;
  step_index: number;
  time_to_submit_ms?: number;
  tool_name?: string;
  used_escape_hatch?: boolean;
};

export type UseTrackAgentElicitationRespondedParams = WorkspaceAgentElicitationRespondedSharedParams &
  (
    | {
        component_type: 'guided_flow';
        elicitation_type: 'guided_flow';
        selected_option_ids: WorkspaceAgentGuidedFlowEditId[];
      }
    | {
        component_type: WorkspaceAgentElicitationComponentType;
        elicitation_type: Exclude<WorkspaceAgentElicitationRespondedType, 'guided_flow'>;
        selected_option_ids?: string[];
      }
  );

export const useTrackAgentElicitationResponded = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentElicitationResponded = useCallback(
    (params: UseTrackAgentElicitationRespondedParams) => {
      track(META.name, withWorkspaceAgentCategory(params));
    },
    [track],
  );

  return { trackAgentElicitationResponded };
};
